import { createAction } from 'redux-actions'
import * as constants from './constants'

export const fetchOrgTeams = createAction(constants.FETCH_ORG_TEAMS)
export const fetchOrgTeamsPending = createAction(constants.FETCH_ORG_TEAMS_PENDING)
export const fetchOrgTeamsSuccess = createAction(constants.FETCH_ORG_TEAMS_SUCCESS)
export const fetchOrgTeamsFailed = createAction(constants.FETCH_ORG_TEAMS_FAILED)

export const fetchTeamsForUser = createAction(constants.FETCH_TEAMS_FOR_USER)
export const fetchTeamsForUserPending = createAction(constants.FETCH_TEAMS_FOR_USER_PENDING)
export const fetchTeamsForUserSuccess = createAction(constants.FETCH_TEAMS_FOR_USER_SUCCESS)
export const fetchTeamsForUserFailed = createAction(constants.FETCH_TEAMS_FOR_USER_FAILED)

export const patchOrgTeam = createAction(constants.PATCH_ORG_TEAM)
export const patchOrgTeamPending = createAction(constants.PATCH_ORG_TEAM_PENDING)
export const patchOrgTeamSuccess = createAction(constants.PATCH_ORG_TEAM_SUCCESS)
export const patchOrgTeamFailed = createAction(constants.PATCH_ORG_TEAM_FAILED)

export const deleteOrgTeam = createAction(constants.DELETE_ORG_TEAM)
export const deleteOrgTeamPending = createAction(constants.DELETE_ORG_TEAM_PENDING)
export const deleteOrgTeamSuccess = createAction(constants.DELETE_ORG_TEAM_SUCCESS)
export const deleteOrgTeamFailed = createAction(constants.DELETE_ORG_TEAM_FAILED)

export const createOrgTeam = createAction(constants.CREATE_ORG_TEAM)
export const createOrgTeamPending = createAction(constants.CREATE_ORG_TEAM_PENDING)
export const createOrgTeamSuccess = createAction(constants.CREATE_ORG_TEAM_SUCCESS)
export const createOrgTeamFailed = createAction(constants.CREATE_ORG_TEAM_FAILED)

export const updateAvailabilityForTeam = createAction(constants.UPDATE_AVAILABILITY_FOR_TEAM)
export const updateAvailabilityForTeamPending = createAction(constants.UPDATE_AVAILABILITY_FOR_TEAM_PENDING)
export const updateAvailabilityForTeamSuccess = createAction(constants.UPDATE_AVAILABILITY_FOR_TEAM_SUCCESS)
export const updateAvailabilityForTeamFailed = createAction(constants.UPDATE_AVAILABILITY_FOR_TEAM_FAILED)

export const fetchTeamAvailabilities = createAction(constants.FETCH_TEAM_AVAILABILITIES)
export const fetchTeamAvailabilitiesPending = createAction(constants.FETCH_TEAM_AVAILABILITIES_PENDING)
export const fetchTeamAvailabilitiesSuccess = createAction(constants.FETCH_TEAM_AVAILABILITIES_SUCCESS)
export const fetchTeamAvailabilitiesFailed = createAction(constants.FETCH_TEAM_AVAILABILITIES_FAILED)

export const fetchTeamAvailability = createAction(constants.FETCH_TEAM_AVAILABILITY)
export const fetchTeamAvailabilityPending = createAction(constants.FETCH_TEAM_AVAILABILITY_PENDING)
export const fetchTeamAvailabilitySuccess = createAction(constants.FETCH_TEAM_AVAILABILITY_SUCCESS)
export const fetchTeamAvailabilityFailed = createAction(constants.FETCH_TEAM_AVAILABILITY_FAILED)

export const createTeamAvailability = createAction(constants.CREATE_TEAM_AVAILABILITY)
export const createTeamAvailabilityPending = createAction(constants.CREATE_TEAM_AVAILABILITY_PENDING)
export const createTeamAvailabilitySuccess = createAction(constants.CREATE_TEAM_AVAILABILITY_SUCCESS)
export const createTeamAvailabilityFailed = createAction(constants.CREATE_TEAM_AVAILABILITY_FAILED)

export const updateTeamAvailability = createAction(constants.UPDATE_TEAM_AVAILABILITY)
export const updateTeamAvailabilityPending = createAction(constants.UPDATE_TEAM_AVAILABILITY_PENDING)
export const updateTeamAvailabilitySuccess = createAction(constants.UPDATE_TEAM_AVAILABILITY_SUCCESS)
export const updateTeamAvailabilityFailed = createAction(constants.UPDATE_TEAM_AVAILABILITY_FAILED)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/teams/actions.js